export function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export function deleteCookie(name) {
  document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
}

export function encodeQueryData(data) {
  const ret = [];
  for (let d in data) {
    if (data[d])
      ret.push(encodeURIComponent(d) + "=" + encodeURIComponent(data[d]));
  }
  let returnValue = ret.join("&");

  return returnValue ? `?${returnValue}` : "";
}
